export const COURSE = '/course/'
export const COURSE_ALL = `${COURSE}all`
